module.exports = __webpack_public_path__ + "img/contactsImg4x.png";